import TruncatedTextCell from "./TruncatedTextCell.vue";

export default TruncatedTextCell;
export { TruncatedTextCell };
